import { debounce } from 'lodash';
import { useEffect, useMemo } from 'react';
import { FieldValues, SubmitHandler, useFormContext } from 'react-hook-form';

interface AutoSubmitProps {
  onSubmit: SubmitHandler<FieldValues>;
  waitTime?: number;
}

const AutoSubmit = ({ onSubmit, waitTime = 300 }: AutoSubmitProps) => {
  const { handleSubmit, watch } = useFormContext();

  const debouncedSubmit = useMemo(
    () => debounce(() => handleSubmit(onSubmit)(), waitTime),
    [handleSubmit, onSubmit, waitTime],
  );

  useEffect(() => {
    const subscription = watch(debouncedSubmit);
    return () => subscription.unsubscribe();
  }, [debouncedSubmit, handleSubmit, onSubmit, watch]);

  // useEffect(() => {
  //   if (!isEqual(initialValues, values)) {
  //     debouncedSubmit();
  //   }
  // }, [debouncedSubmit, initialValues, values]);

  return <></>;
};

export default AutoSubmit;
